
























import { Vue, Component, Prop } from "vue-property-decorator";
import { monthName } from "@common/dateTimeHelper";
import { BarItemInterface, DisplayBarItemInterface } from "../interfaces/AnalyticsInterfaces";

@Component({
    components: { }
})
export default class AnalyticsBars extends Vue {
    @Prop({required: true}) values: BarItemInterface[];
    @Prop({required: true}) title: string;
    @Prop({required: false, default: false}) formatToTime: boolean;
    @Prop({default: false}) isGreen: boolean;

    static SIZE = 7;

    get language() {
        return this.$store.state.session.language ?? 'en';
    }

    get displayValues(): DisplayBarItemInterface[] {
        const size = this.values.length,
            startIndex = (size > AnalyticsBars.SIZE) ? size - AnalyticsBars.SIZE : 0,
            endIndex = startIndex + AnalyticsBars.SIZE,
            visibleData = this.values.slice(startIndex, endIndex),
            max = Math.max(...visibleData.map((item) => item?.value)),
            normalizedData = visibleData.map((item) => {
                return {
                    value: this.formatToTime
                        ? this.timeFormat(item.value)
                        : item.value.toString(),
                    percents: (item.value > 0)
                        ? Math.round(item.value / max * 100) 
                        : 0,
                    day: item.date.day,
                    month: monthName(item.date.month, this.language)
                } as DisplayBarItemInterface;
            });        

        return normalizedData;
    }

    timeFormat(value: number): string {
        if (value >= 60 * 60) {
            return new Date(value * 1000).toISOString().substr(11, 8)
        } else {
            return new Date(value * 1000).toISOString().substr(14, 5)
        }
    }
}
